module.exports = __webpack_public_path__ + "img/hand_sideleft_41.2eb077f0.svg";